import type { ProductImage } from '@gozoki/api-types'
import { z } from 'zod'

export const zInputFile = z.object({
  blob: z.instanceof(Blob),
  frontendId: z.string(),
  id: z.number().nullable(),
  toDelete: z.boolean(),
})

export type InputFile = z.infer<typeof zInputFile>

// Helper : resolve image array from a list of image attachment
export const resolveImages = async (images: ProductImage[]): Promise<InputFile[]> => {
  const resolvedImages = await Promise.all(
    images
      .filter(({ image }) => image.url !== undefined)
      .map(async ({ image, id }) => {
        const response = await fetch(image.url!)
        const blob = await response.blob()
        return { blob, frontendId: Math.random().toString(), id, toDelete: false }
      }),
  )

  return resolvedImages
}

// Generate a local URL from a File object in order to display it in an <img> tag
export const generateLocalUrl = (imageBlob: Blob) => URL.createObjectURL(imageBlob)

export const parseFileTypeFromName = (name: string) => {
  const extension = name.split('.').pop() ?? 'png'

  if (extension === 'svg') {
    return 'image/svg+xml'
  }

  return `image/${extension}`
}
